import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

// Preview of a column's values for a mapping dropdown: a numeric range, or the most common
// values with their count. Domain-agnostic - works on any column name + row set.
@Pipe({ name: 'columnValueInfo', standalone: false })
export class ColumnValueInfoPipe implements PipeTransform {
    transform(column: string, rows: Record<string, unknown>[]): string {
        if (!rows?.length || !column) {
            return '';
        }

        const values = rows
            .map(row => row[column])
            .filter(value => value !== null && value !== undefined && value !== '');

        if (values.length === 0) {
            return '';
        }

        const numericValues = values.filter(value => !isNaN(Number(value))).map(value => Number(value));
        const isFullyNumeric = numericValues.length > 0 && numericValues.length === values.length;

        if (isFullyNumeric && new Set(numericValues).size >= 10) {
            const nonZeroValues = numericValues.filter(value => value !== 0);

            if (nonZeroValues.length === 0) {
                return '0';
            }

            const min = Math.min(...nonZeroValues);
            const max = Math.max(...nonZeroValues);
            const avg = nonZeroValues.reduce((a, b) => a + b, 0) / nonZeroValues.length;

            return `${formatNumber(min, 'nl', '1.0-2')}-${formatNumber(max, 'nl', '1.0-2')} ~${formatNumber(avg, 'nl', '1.0-2')}`;
        }

        const valueCounts = new Map<string, number>();

        values.forEach(value => {
            const str = String(value);
            valueCounts.set(str, (valueCounts.get(str) || 0) + 1);
        });

        const sortedValues = Array.from(valueCounts.entries()).sort((a, b) => b[1] - a[1]);
        const displayValues = sortedValues.slice(0, 5).map(([value, count]) => `${value} (${count})`);
        const result = displayValues.join(', ');

        return sortedValues.length > 5 ? `${result}... +${sortedValues.length - 5} meer` : result;
    }
}
